import { render, staticRenderFns } from "./AppChatRoom.vue?vue&type=template&id=5fb19019&scoped=true&"
import script from "./AppChatRoom.vue?vue&type=script&lang=ts&"
export * from "./AppChatRoom.vue?vue&type=script&lang=ts&"
import style0 from "./AppChatRoom.vue?vue&type=style&index=0&id=5fb19019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb19019",
  null
  
)

export default component.exports